<template>
  <div class="card-list">
    <overlay
      :is-loading="isLoading"
    />
    <v-row
      justify="center"
      no-gutters
      class="card-list-wrapper"
    >
      <div
        v-for="(card,index) in filteredCards"
        :key="`${card.slug}-${index}`"
      >
        <card-viewer
          :card="card"
          :show-last-scores="showLastScores"
          show-fixture
          :show-average-score="showAverageScore"
          :is-clickable="!isSelectedCard(card) && !isForbiddenCard(card) && isClickable"
          :is-selected="isSelectedCard(card)"
          :is-forbidden="isForbiddenCard(card)"
          @cardClicked="cardPicked($event)"
        />
      </div>
    </v-row>
  </div>
</template>

<script>
import CardViewer from '@/components/Card/CardViewer.vue';
import Overlay from '@/components/Overlay.vue';
import UserService from '@/services/user.service';
import PaginatedCardCollection from '@/models/Card/paginatedCardCollection';
import { useCardFilterStore } from '@/store/cardFilter.module';

export default {
  name: 'CardsList',
  setup() {
    const cardFilterStore = useCardFilterStore();

    return { cardFilterStore };
  },
  components: {
    Overlay,
    CardViewer,
  },
  props: {
    userSlug: {
      type: String,
      default: null,
    },
    gameWeekNumber: {
      type: Number,
      default: null,
    },
    showLastScores: {
      type: Boolean,
      default: false,
    },
    showAverageScore: {
      type: Boolean,
      default: false,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
    selectedCards: {
      type: Array,
      default() {
        return [];
      },
    },
    forbiddenCards: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isLoading: true,
      paginatedCardCollection: new PaginatedCardCollection(),
    };
  },
  computed: {
    filteredCards() {
      const filteredCards = this.paginatedCardCollection.cards.filter(
        (card) => {
          const edition = !card.isLegend();
          let scarcity = !card.isCommon() && !card.isCustomSeries();
          if (this.cardFilterStore.filter.property.scarcity.length > 0) {
            scarcity = this.cardFilterStore.filter.property.scarcity.includes(card.scarcity);
          }

          let position = true;
          if (this.cardFilterStore.filter.property.position.length > 0) {
            position = this.cardFilterStore.filter.property.position.includes(card.position);
          }

          let isPlayingGw = true;
          if (this.cardFilterStore.filter.property.isPlayingGw) {
            isPlayingGw = card.fixture !== null;
          }

          const search = card.player.displayName.toLowerCase().includes(this.cardFilterStore.filter.search.toLowerCase());

          return scarcity && edition && position && isPlayingGw && search;
        },
      );

      const sortProp = this.cardFilterStore.filter.sort.property;
      const direction = this.cardFilterStore.filter.sort.direction;
      filteredCards.sort((a, b) => {
        const aValue = sortProp === 'last15Average' ? a.player.last15Average : a[sortProp];
        const bValue = sortProp === 'last15Average' ? b.player.last15Average : b[sortProp];
        if (aValue > bValue) {
          return direction === 'ASC' ? 1 : -1;
        }

        if (aValue < bValue) {
          return direction === 'ASC' ? -1 : 1;
        }

        return 0;
      });

      return filteredCards;
    },
  },
  mounted() {
    this.getUserCards();
  },
  methods: {
    cardPicked(card) {
      this.$emit('cardPicked', card);
    },
    isSelectedCard(card) {
      return this.selectedCards.map((selectedCard) => selectedCard.slug).includes(card.slug);
    },
    isForbiddenCard(card) {
      return this.forbiddenCards.includes(card.slug);
    },
    getUserCards() {
      this.isLoading = true;
      UserService.getUserCards(this.userSlug, this.gameWeekNumber, this.paginatedCardCollection.cursor)
        .then((response) => {
          this.paginatedCardCollection.aggregate(response);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card-list {
  position: relative;
  min-height: 50px;
  overflow: auto;
}

.card-list-wrapper {
  gap: 14px;
}
</style>
